module.exports = __webpack_public_path__ + "static/img/friend5.e905341.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/friend5.jpeg
// module id = gnNx
// module chunks = 1